import React, { useEffect, useState } from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  const [data, setData] = useState(null);

  useEffect(() => {
    console.log("✅ GitHub Component Mounted"); // Check if this logs
    fetch("https://github-contributions-api.jogruber.de/v4/Amaan-AeonX")
      .then((res) => res.json())
      .then((json) => {
        console.log("🔹 GitHub Contributions Data:", json);
        setData(json);
      })
      .catch((error) => console.error("❌ API Fetch Error:", error));
  }, []);

  const colourTheme = {
    background: "transparent",
    text: "#ffffff",
    grade4: "#8400b8",
    grade3: "#b22ff4",
    grade2: "#b265f6",
    grade1: "#c084f5",
    grade0: "#252525",
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      {data ? (
        <GitHubCalendar
          username="Amaan-AeonX"
          blockSize={15}
          blockMargin={5}
          fontSize={16}
          showTotalCount={true}
          hideColorLegend={false}
          theme={colourTheme}
        />
      ) : (
        <p>Loading Contributions...</p>
      )}
    </Row>
  );
}

export default Github;
